{
  "schema": "ft.wall-projectiles.v1",
  "massive": {
    "16356F85-AEBE-9F69-09CB-3F507ADA3B20": "Boulder Throw (120) (3d10)",
    "D23E8A7A-4A21-1C3A-4626-1FDC2C18F0A4": "Boulder Throw (120) (4d10)",
    "B305C730-B8CD-95EC-3B74-74B3B5617C91": "Boulder Throw (120) (4d12)",
    "EE8E5658-519C-79EA-3B92-C28811CD4E12": "Blazing Boulder",
    "3405CFED-59F4-E9F1-7270-339624A673E5": "Hurled Boulder",
    "442B805C-9DF5-ABE0-3535-33F524B0C271": "Ballista Bolt (60) (d6)",
    "4E43ABDE-21AA-B16A-D1E8-944098789EF4": "Ballista Shot"
  }
}
